import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';

import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import Layout from 'react-toolbox/lib/layout/Layout';
import Panel from 'react-toolbox/lib/layout/Panel';

import Header from './Header';
import Footer from './Footer';

import About from './components/About';
import Reviews from './components/Reviews';
import Sites from './components/Sites';

import Clinics from './clinics/containers/Clinics';
import Payments from './payments/containers/Payments';
import Contact from './contact/containers/Contact';
import Tandems from './tandems/containers/Tandems';
import Tours from "./tours/containers/Tours";

import styled from 'styled-components';

import theme from '../toolbox/theme';

/*
 FIXME - HTTP/HTTPS router condition
 FIXME - sign up for newsletter
 FIXME - Paraglide Utah conditional background image
 */

const Main = styled.main`
    @media (min-width: 751px) {
        margin-top: 55px;
        flex: 1;
    }
    @media (max-width: 750px) {
        margin-top: 25px;
        flex: 1;
    }
`;

const StyledPanel = styled(Panel)`
    display: flex;
    flex-flow: column;
    height: 100vh;
`;

export default () => {
    return (
        <ThemeProvider theme={theme}>
            <Layout>
                <Router>
                    <StyledPanel>
                        <Header/>
                        <Main>
                            <Switch>
                                <Route exact path='/' render={() => <Redirect to='/siv-clinics'/>}/>
                                <Route path='/about-us' component={About}/>
                                <Route path='/reviews' component={Reviews}/>
                                <Route path='/sites' component={Sites}/>
                                <Route path='/tandem-flights' component={Tandems}/>
                                <Route path='/travel-tours' component={Tours}/>
                                <Route path='/siv-clinics' component={Clinics}/>
                                <Route path='/payments' component={Payments}/>
                                <Route path='/contact' component={Contact}/>}/>
                            </Switch>
                        </Main>
                        <Footer/>
                    </StyledPanel>
                </Router>
            </Layout>
        </ThemeProvider>
    )
}



// WEBPACK FOOTER //
// ./src/app/Application.js